import { render, staticRenderFns } from "./serviceCloud.vue?vue&type=template&id=4fcbaafd&scoped=true&"
import script from "./serviceCloud.vue?vue&type=script&lang=js&"
export * from "./serviceCloud.vue?vue&type=script&lang=js&"
import style0 from "./serviceCloud.vue?vue&type=style&index=0&id=4fcbaafd&prod&scoped=true&lang=css&"
import style1 from "./serviceCloud.vue?vue&type=style&index=1&id=4fcbaafd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcbaafd",
  null
  
)

export default component.exports